import { render } from "./WeeklyPlans.vue?vue&type=template&id=3d244073&scoped=true"
import script from "./WeeklyPlans.vue?vue&type=script&lang=js"
export * from "./WeeklyPlans.vue?vue&type=script&lang=js"

import "./WeeklyPlans.vue?vue&type=style&index=0&id=3d244073&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d244073"]])

export default __exports__